__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@niarab2c/core-reservations-front";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("react-dom", "^18.1.0", () => (Promise.all([__webpack_require__.e(43144), __webpack_require__.e(75641)]).then(() => (() => (__webpack_require__(43144))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(69074), __webpack_require__.e(13639), __webpack_require__.e(75641), __webpack_require__.e(11283)]).then(() => (() => (__webpack_require__(33664))))));
			register("react-router", "5.3.4", () => (Promise.all([__webpack_require__.e(69074), __webpack_require__.e(86090), __webpack_require__.e(75641), __webpack_require__.e(14363)]).then(() => (() => (__webpack_require__(86090))))));
			register("react-toastify", "9.1.1", () => (Promise.all([__webpack_require__.e(75641), __webpack_require__.e(80002)]).then(() => (() => (__webpack_require__(57621))))));
			register("react", "^18.2.0", () => (__webpack_require__.e(14041).then(() => (() => (__webpack_require__(14041))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};